"use strict";
module.exports = decoder;

var Enum    = require(16),
    types   = require(37),
    util    = require(38);

function missing(field) {
    return "missing required '" + field.name + "'";
}

/**
 * Generates a decoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */
function decoder(mtype) {
    /* eslint-disable no-unexpected-multiline */
    var gen = util.codegen(["r", "l", "e", "n"], mtype.name + "$decode")
    ("if(!(r instanceof Reader))")
        ("r=Reader.create(r)")
    ("if(n===undefined)n=0")
    ("if(n>Reader.recursionLimit)")
        ("throw Error(\"maximum nesting depth exceeded\")")
    ("var c,m" + (mtype.fieldsArray.filter(function(field) { return field.map; }).length ? ",k,value" : ""))
    ("if(l===undefined)")
        ("c=r.len")
    ("else{")
        ("c=r.pos+l")
        ("if(c>r.len)")
            ("throw RangeError(\"index out of range\")")
        ("l=r.len")
        ("r.len=c")
    ("}")
    ("m=new this.ctor")
    ("while(r.pos<c){")
        ("var t=r.uint32()")
        ("if(t===e)")
            ("break")
        ("switch(t>>>3){");

    var i = 0;
    for (; i < /* initializes */ mtype.fieldsArray.length; ++i) {
        var field = mtype._fieldsArray[i].resolve(),
            type  = field.resolvedType instanceof Enum ? "int32" : field.type,
            ref   = "m" + util.safeProp(field.name); gen
            ("case %i: {", field.id);

        // Map fields
        if (field.map) { gen
                ("if(%s===util.emptyObject)", ref)
                    ("%s={}", ref)
                ("var c2=r.uint32()+r.pos")
                ("if(c2>r.len)")
                    ("throw RangeError(\"index out of range\")")
                ("r.len=c2");

            if (types.defaults[field.keyType] !== undefined) gen
                ("k=%j", types.defaults[field.keyType]);
            else gen
                ("k=null");

            if (types.defaults[type] !== undefined) gen
                ("value=%j", types.defaults[type]);
            else gen
                ("value=null");

            gen
                ("while(r.pos<c2){")
                    ("var tag2=r.uint32()")
                    ("switch(tag2>>>3){")
                        ("case 1: k=r.%s(); break", field.keyType)
                        ("case 2:");

            if (types.basic[type] === undefined) gen
                            ("value=types[%i].decode(r,r.uint32(),undefined,n+1)", i); // can't be groups
            else gen
                            ("value=r.%s()", type);

            gen
                            ("break")
                        ("default:")
                            ("r.skipType(tag2&7,n)")
                            ("break")
                    ("}")
                ("}")
                ("if(r.pos!==c2)")
                    ("throw RangeError(\"index out of range\")")
                ("r.len=c");

            if (types.long[field.keyType] !== undefined) gen
                ("%s[typeof k===\"object\"?util.longToHash(k):k]=value", ref);
            else {
                if (field.keyType === "string") gen
                ("if(k===\"__proto__\")")
                    ("util.makeProp(%s,k)", ref);
                gen
                ("%s[k]=value", ref);
            }

        // Repeated fields
        } else if (field.repeated) { gen

                ("if(!(%s&&%s.length))", ref, ref)
                    ("%s=[]", ref);

            // Packable (always check for forward and backward compatiblity)
            if (types.packed[type] !== undefined) gen
                ("if((t&7)===2){")
                    ("var c2=r.uint32()+r.pos")
                    ("if(c2>r.len)")
                        ("throw RangeError(\"index out of range\")")
                    ("r.len=c2")
                    ("while(r.pos<c2)")
                        ("%s.push(r.%s())", ref, type)
                    ("if(r.pos!==c2)")
                        ("throw RangeError(\"index out of range\")")
                    ("r.len=c")
                ("}else");

            // Non-packed
            if (types.basic[type] === undefined) gen(field.delimited
                    ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4),n+1))"
                    : "%s.push(types[%i].decode(r,r.uint32(),undefined,n+1))", ref, i);
            else gen
                    ("%s.push(r.%s())", ref, type);

        // Non-repeated
        } else if (types.basic[type] === undefined) gen(field.delimited
                ? "%s=types[%i].decode(r,undefined,((t&~7)|4),n+1)"
                : "%s=types[%i].decode(r,r.uint32(),undefined,n+1)", ref, i);
        else gen
                ("%s=r.%s()", ref, type);
        gen
                ("break")
            ("}");
        // Unknown fields
    } gen
            ("default:")
                ("r.skipType(t&7,n)")
                ("break")

        ("}")
    ("}");

    gen
    ("if(l!==undefined){")
        ("if(r.pos!==c)")
            ("throw RangeError(\"index out of range\")")
        ("r.len=l")
    ("}");

    // Field presence
    for (i = 0; i < mtype._fieldsArray.length; ++i) {
        var rfield = mtype._fieldsArray[i];
        if (rfield.required) gen
            ("if(!Object.hasOwnProperty.call(m,%j))", rfield.name)
        ("throw util.ProtocolError(%j,{instance:m})", missing(rfield));
    }

    return gen
    ("return m");
    /* eslint-enable no-unexpected-multiline */
}
